import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class IntercomHelperService {
  async boot(configuracion: any): Promise<void> {
    await this.ensureIntercomLoaded();
    try {
      (window as any).Intercom('boot', {
        ...configuracion
      });
    } catch (err) {
      console.error('Intercom boot failed:', err);
    }
  }

  shutdown() {
    const ic = (window as any).Intercom;
    if (typeof ic === 'function') {
      try { ic('shutdown'); } catch (err) { console.error('Intercom shutdown failed:', err); }
    } else {
      // nothing to shutdown
    }
  }

  update(data: any) {
    const ic = (window as any).Intercom;
    if (typeof ic === 'function') {
      try { ic('update', data); } catch (err) { console.error('Intercom update failed:', err); }
    } else {
      // not ready: if stub exists it will queue; otherwise ignore
    }
  }

  private ensureIntercomLoaded(): Promise<void> {
    return new Promise((resolve) => {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return resolve();
      }

      const w = window as any;

      if (typeof w.Intercom === 'function') {
        return resolve();
      }

      // If another caller is already loading the script, wait until Intercom becomes a function
      if (w.__intercomLoading) {
        const checkInterval = setInterval(() => {
          if (typeof w.Intercom === 'function') {
            clearInterval(checkInterval);
            resolve();
          }
        }, 100);
        // safety timeout
        setTimeout(() => { clearInterval(checkInterval); resolve(); }, 10000);
        return;
      }

      w.__intercomLoading = true;

      // create a stub function that queues calls until the real script is loaded
      const i = function() { (i as any).c(arguments); } as any;
      i.q = [];
      i.c = function(args: any) { i.q.push(args); };
      w.Intercom = i;

      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = 'https://widget.intercom.io/widget/' + INTERCOM_APP_KEY;
      s.onload = () => {
        // give the script a moment to initialise
        setTimeout(() => { resolve(); }, 50);
      };
      s.onerror = () => {
        console.error('Intercom script failed to load');
        resolve();
      };

      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(s, firstScript);
      } else {
        document.head.appendChild(s);
      }
    });
  }

  intercom_config(user_id: string): { [key: string]: any } {
    return {
      "app_id": INTERCOM_APP_KEY,
      "user_id":`${user_id}`,
      "uses_fintech": true,
      "last_fintech_access": new Date().toISOString()
    }
  }
}

const INTERCOM_APP_KEY = 'd7im2cqy'; 
